import { Outlet } from 'react-router';

import { HeroPattern } from '@/components/hero-pattern';

export function AuthLayout() {
  return (
    <>
      <HeroPattern />
      <div className="flex flex-col justify-center pt-12 lg:min-h-screen lg:pt-0">
        <div className="h-full">
          <Outlet />
        </div>
      </div>
    </>
  );
}
